import React from "react";
import Loans from "../Loans/Loans";
import WalletHistory from "../Installment/WalletHistory";

// Combined payment tab: Lead Overview + Credit History (wallet) on one page.
const LeadCredit = () => {
  return (
    <div>
      <div style={{ marginBottom: "28px" }}>
        <Loans isPayment />
      </div>
      <WalletHistory />
    </div>
  );
};

export default LeadCredit;
